export const SiteCredits = () => {
  return (
    <div className="credits">
      © 2024 Multicook Brandon | By{" "}
      <a
        href="https://www.linkedin.com/in/vadym-kochenko/"
        target="_blank"
        rel="noreferrer"
      >
        Vadym Kochenko
      </a>
    </div>
  );
};
